import { ArrowLeftOutlined } from '@ant-design/icons'
import { Button, Flex, Progress, Typography } from 'antd'
import { FC, useMemo } from 'react'

type ProgressHeaderProps = {
  title: string;
  onBack: () => void;
  sectionIndex: number;
  last: number;
  description: string;
}

export const ProgressHeader: FC<ProgressHeaderProps> = ({ title, onBack, sectionIndex, last, description }) => {
  const percent = useMemo(() => ((sectionIndex + 1) / (last + 1)) * 100, [sectionIndex, last]);

  return (
    <div>
      <Flex vertical gap={8}>
        <Flex align='center' style={{ position: 'relative' }}>
          {sectionIndex > 0 && <Button style={{ position: 'absolute', left: '0', transform: 'translateX(-100%)' }} ghost type='link' size='small' onClick={onBack}>
            <ArrowLeftOutlined style={{ color: '#000', fontSize: 24 }} />
          </Button>}
          <Typography.Title level={2}>{title}</Typography.Title>
        </Flex>
        <Typography.Text>{description}</Typography.Text>
        <Progress style={{ marginTop: 8 }} showInfo={false} percent={percent} />
      </Flex>
    </div>
  )
}